import { NgModule } from '@angular/core';
import { StartObserveObservationComponent } from './start-observe-observation/start-observe-observation.component';

import { PHBHPFeaturePackageObserveObservationComponent } from './ph-bhp-feature-package-observe-observation.component';
import { PhBhpObserveObservationProtocolComponent } from './ph-bhp-observe-observation-protocol/ph-bhp-observe-observation-protocol.component';
import { PhBhpNewObserveObservationComponent } from './ph-bhp-new-observe-observation/ph-bhp-new-observe-observation.component';
import { PHBHPLayoutPackageModule } from 'ph-bhp-feature-packages/ph-bhp-layout-package/public_api';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { PhBhpObserveObservationComponent } from './ph-bhp-observe-observation/ph-bhp-observe-observation.component';
import { PhBhpFrequentCategoryComponent } from './ph-bhp-frequent-category/ph-bhp-frequent-category.component';
import { PhBhpSelectCategoryComponent } from './ph-bhp-select-category/ph-bhp-select-category.component';
import { PhBhpObservationProtocolFeedbackComponent } from './ph-bhp-observation-protocol-feedback/ph-bhp-observation-protocol-feedback.component';
import { PhBhpObservationMomentsComponent } from './ph-bhp-observation-moments/ph-bhp-observation-moments.component';
import { PhBhpObserveProtocolObservationListComponent } from './ph-bhp-observe-protocol-observationList/ph-bhp-observe-protocol-observationList.component';
import { PhBhpObserveProtocolObservationHeadingComponent } from './ph-bhp-observe-protocol-observationHeading/ph-bhp-observe-protocol-observationHeading.component';
import { TabsModule } from 'ngx-bootstrap/tabs';
import { SelectObserveObservationComponent } from './select-observe-observation/select-observe-observation.component';
import { PHBHPLocalizePackageModule } from 'ph-bhp-feature-packages/ph-bhp-localize-package/lib/ph-bhp-localize-package.module';
import { PHBHPFeaturePackageEvaluationModule } from 'ph-bhp-feature-packages/ph-bhp-feature-package-evaluation/public_api';
import { PhBhpUiModule } from 'ph-bhp-feature-packages/ph-bhp-ui/src/lib/ph-bhp-ui.module';
import { MatIconModule } from '@angular/material/icon';
import { MatSelectModule } from '@angular/material/select';
import { MatRadioModule } from '@angular/material/radio';
import { MatListModule } from '@angular/material/list';
import { ClientLibModule } from 'ph-bhp-feature-packages/ph-bhp-feature-package-check/public_api';
import { PhBhpFeatureComponentsModule } from 'ph-bhp-feature-packages/ph-bhp-feature-components/public_api';
// common libraries


@NgModule({
    declarations: [
        StartObserveObservationComponent,
        SelectObserveObservationComponent,
        PHBHPFeaturePackageObserveObservationComponent,
        PhBhpObserveObservationProtocolComponent,
        PhBhpObservationProtocolFeedbackComponent,
        PhBhpObserveProtocolObservationListComponent,
        PhBhpObserveProtocolObservationHeadingComponent,
        PhBhpNewObserveObservationComponent,
        PhBhpObserveObservationComponent,
        PhBhpFrequentCategoryComponent,
        PhBhpSelectCategoryComponent,
        PhBhpObservationMomentsComponent
    ],
    imports: [
        BsDropdownModule.forRoot(),
        PHBHPLayoutPackageModule,
        PHBHPLocalizePackageModule,
        TabsModule.forRoot(),
        PHBHPFeaturePackageEvaluationModule,
        PhBhpUiModule,
        MatIconModule,
        MatSelectModule,
        MatRadioModule,
        MatListModule,
        ClientLibModule,
        PhBhpFeatureComponentsModule
    ]
})
export class PHBHPFeaturePackageObserveObservationModule { }
